import { SVGProps } from 'react';

export type LinkedinAdsIconProps = SVGProps<SVGSVGElement>;

/** LinkedIn brand mark (the "in" tile), used for the LinkedIn Ads integration. */
export const LinkedinAdsIcon = ({ className, ...props }: LinkedinAdsIconProps) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect x="4" y="4" width="40" height="40" rx="6" fill="#0A66C2" />
    <path
      d="M13.2 19.3h4.9V35h-4.9V19.3Zm2.45-7.8a2.85 2.85 0 1 1 0 5.7 2.85 2.85 0 0 1 0-5.7ZM21.2 19.3h4.7v2.15h.07c.65-1.24 2.25-2.55 4.64-2.55 4.96 0 5.88 3.27 5.88 7.52V35h-4.9v-7.6c0-1.82-.03-4.15-2.53-4.15-2.53 0-2.92 1.98-2.92 4.02V35h-4.9V19.3Z"
      fill="#fff"
    />
  </svg>
);
